import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {injectIntl} from "react-intl";
import AgoraRTC from "agora-rtc-sdk-ng";
import useAgora from "utils/useAgora";
import useAgoraRTM from "utils/useAgoraRTM";
import * as request from "api-socket/chat";
import {usePrevState} from "utils/usePrevState";
import {URL, PLAY_MODE_ACTION, PRIVATE_CHAT_LIST, VOICE_CHAT_TYPE} from "utils/constants";
import {showPopUp, TwoBtnPopUp} from "components/PopUp";
import View from "./View";

const APP_ID = "ae1d008bd852448ebc15c6ad02b4ebd9";
const worldClient = AgoraRTC.createClient({codec: "h264", mode: "rtc"});
const privateClient = AgoraRTC.createClient({codec: "h264", mode: "rtc"});

const Container = ({intl}) => {
  const isSelfieModeActive = useSelector(state => state.selfie.isActivated);
  const playOption = useSelector(state => state.playOption);
  const roomName = useSelector(state => state.chat.currentRoom);
  const userInfo = useSelector(state => state.userinfo);
  const [currentChatMode, setCurrentChatMode] = useState(VOICE_CHAT_TYPE[2]);
  const [voiceChatType, setVoiceChatType] = useState(VOICE_CHAT_TYPE[0]);
  const [privateTab, setPrivateTab] = useState(PRIVATE_CHAT_LIST[0]);
  const [miniMode, setMiniMode] = useState(false);
  const [userList, setUserList] = useState([]);
  const prevPrivateTab = usePrevState(privateTab);
  const [worldName, setWorldName] = useState("");

  const {
    remoteUsers,
    micStatus,
    audioStatus,
    volumeData,
    generateVoiceChatToken,
    join,
    leave,
    getDevices,
    switchDevice,
    getVolume,
    setVolume,
    micTestStart,
    micTestStop,
    speakerTestStart,
    speakerTestStop,
    setMuted,
  } = useAgora(APP_ID, worldClient, "world");
  const agoraPrivateClient = useAgora(APP_ID, privateClient, "private");

  const {callId, privateChatInfo, status, privateOtherPersonName, login, logout, getUserAttributes, sendCall, getMembers, setStatus} =
    useAgoraRTM();

  useEffect(() => {
    if (userInfo.id) {
      rtmJoin();
    }
    return () => {
      logout();
    };
  }, [userInfo.id]);

  useEffect(() => {
    if (voiceChatType === VOICE_CHAT_TYPE[0]) {
      setUserList(remoteUsers);
    }
    if (remoteUsers.length > 0) {
      remoteUsers.map(user => user.audioTrack?.play());
    }
  }, [remoteUsers]);

  useEffect(() => {
    if (status === "meeting" && agoraPrivateClient.remoteUsers.length > 0) {
      agoraPrivateClient.remoteUsers.map(user => user.audioTrack?.play());
    }
  }, [status, agoraPrivateClient.remoteUsers]);

  useEffect(() => {
    if (agoraPrivateClient.isUserLeft) {
      setStatus("onLine");
      onClickLeaveChat();
    }
  }, [agoraPrivateClient.isUserLeft]);

  useEffect(() => {
    if (status === "meeting") {
      if (voiceChatType !== VOICE_CHAT_TYPE[1]) {
        onClickTypeTab(VOICE_CHAT_TYPE[1]);
      }
      if (currentChatMode === VOICE_CHAT_TYPE[0]) {
        onClickLeaveChat();
        onClickEnterChat(VOICE_CHAT_TYPE[1]);
      } else if (currentChatMode === VOICE_CHAT_TYPE[2]) {
        onClickEnterChat(VOICE_CHAT_TYPE[1]);
      }
    }
    if (status === "calling") {
      if (currentChatMode === VOICE_CHAT_TYPE[0]) {
        onClickLeaveChat();
      }
    }
    if (status === "cancel") {
      if (currentChatMode === VOICE_CHAT_TYPE[1]) {
        onClickLeaveChat();
      }
      setStatus("onLine");
    }
  }, [status]);

  const rtmJoin = async () => {
    const token = await getRtmToken();
    if (token) {
      await login(token);
    } else {
      console.error("not exist token");
    }
  };

  const getRtmToken = async () => {
    const rtmToken = await request
      .generateRtmToken()
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          return data.rtmToken;
        }
      });
    return rtmToken;
  };

  const onClickEnterChat = type => {
    if (userInfo.verifiedEmail && userInfo.phone) {
      createAgoraClient(type);
    } else {
      // showPopUp(
      //   <TwoBtnPopUp
      //     title={intl.formatMessage({id: "ID_VOICE_CHAT_VERIFIED_POPUP_INFO"})}
      //     confirmBtn={intl.formatMessage({
      //       id: "ID_VOICE_CHAT_VERIFIED_POPUP_CONFIRM",
      //     })}
      //     confirmAction={() => window.open(URL.REDBRICK_LAND + "/settings", "_blank")}
      //   />,
      //   {defaultPadding: false},
      // );
    }
  };

  const onClickLeaveChat = async () => {
    if (currentChatMode === VOICE_CHAT_TYPE[0]) {
      await leave();
      setCurrentChatMode(VOICE_CHAT_TYPE[2]);
    } else if (currentChatMode === VOICE_CHAT_TYPE[1]) {
      await agoraPrivateClient.leave();
      setCurrentChatMode(VOICE_CHAT_TYPE[2]);
    }
  };

  const createAgoraClient = async type => {
    const userId = userInfo.id;
    const id = new Buffer.from(userId).toString("base64");
    if (type === VOICE_CHAT_TYPE[0]) {
      const token = await generateVoiceChatToken(id, roomName);
      await join(id, roomName, token);
    } else if (type === VOICE_CHAT_TYPE[1]) {
      const _roomName = roomName + privateChatInfo;
      const token = await generateVoiceChatToken(id, _roomName);
      await agoraPrivateClient.join(id, _roomName, token);
    }
    setCurrentChatMode(type);
  };

  const onClickTypeTab = type => {
    if (voiceChatType === type) return;
    setVoiceChatType(type);
  };

  const onClickPrivateTab = tab => {
    if (privateTab === tab) return;
    setPrivateTab(tab);
  };

  const onClickViewMode = () => {
    setMiniMode(!miniMode);
  };

  return (
    <View
      isSelfieModeActive={isSelfieModeActive}
      voiceChatType={voiceChatType}
      isShowVoiceChat={playOption === PLAY_MODE_ACTION.VOICE_CHAT}
      userList={userList}
      miniMode={miniMode}
      privateTab={privateTab}
      prevPrivateTab={prevPrivateTab}
      privateChatStatus={status}
      micStatus={micStatus}
      audioStatus={audioStatus}
      callId={callId}
      agoraPrivateClient={agoraPrivateClient}
      currentChatMode={currentChatMode}
      volumeData={volumeData}
      privateOtherPersonName={privateOtherPersonName}
      onClickViewMode={onClickViewMode}
      onClickTypeTab={onClickTypeTab}
      onClickPrivateTab={onClickPrivateTab}
      onClickEnterChat={onClickEnterChat}
      onClickLeaveChat={onClickLeaveChat}
      getDevices={getDevices}
      switchDevice={switchDevice}
      getVolume={getVolume}
      setVolume={setVolume}
      micTestStart={micTestStart}
      micTestStop={micTestStop}
      speakerTestStart={speakerTestStart}
      speakerTestStop={speakerTestStop}
      setMuted={setMuted}
      sendCall={sendCall}
      getUserAttributes={getUserAttributes}
      getMembers={getMembers}
      setStatus={setStatus}
      worldName={worldName}
    />
  );
};

export default injectIntl(Container);
